/*
 * These types don't contain the actual questions, they're just here to represent
 * listings of fields and subjects that the host can choose from.
 * 
 * It goes Field -> Topic -> Questions
 * like:
 * Modern Art -> Some Famous Painter's name -> What's his most famous painting?
 * 
 */
export interface Field_Listing {
    name: string
    subjects: Subject_Listing[]
}

export interface Subject_Listing {
    field: string
    name: string
}

export interface Trivia_Fields {
    fields: Field_Listing[]
}

export const CUSTOM_QUESTIONS = 'CUSTOM_QUESTIONS'


export enum Question_Type {
    text = 'text',
    multiple_choice = 'multiple_choice',
    closest_number = 'closest_number',
    audio = 'audio',
}

export interface Trivia_Question {
    id: string
    enabled: boolean
    question_text: string
    answer_text: string
    answer_number: number
    field_name: string
    subject_name: string
    type: Question_Type
    difficulty: number
    created_time: number
    created_by: string
    audio_id: string
    audio_length: number
    multiple_choice_answer_1: string
    multiple_choice_answer_2: string
    multiple_choice_answer_3: string
    multiple_choice_answer_4: string
    multiple_choice_answer_5: string
    multiple_choice_answer_6: string
    multiple_choice_answer_7: string
    multiple_choice_answer_8: string
}

// A type for the player's view of the question - 
// no answers, and just info about the question and any possible
// multiple choice options
export interface Player_Question {
    question_text: string
    difficulty: number
    multiple_choice_options?: number
}


export interface Question {
    question_text: string
    difficulty: number
}

export interface Single_Answer_Question extends Question {
    answer_text: string
}

export function is_single_answer_question(q: Question): q is Single_Answer_Question {
    return typeof((q as any)?.answer_text) === "string"
}

export interface Multiple_Choice_Question extends Question {
    options: string[]
    /** correct option is the array index of the correct option, and should be converted to a letter when displayed to the user */
    correct_option: number
}

export function is_multiple_choice_question(q: Question): q is Multiple_Choice_Question {
    return typeof((q as any)?.options) === 'object'
}

